import React, { useState, useRef, useEffect } from "react";
import styles from './user.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { postLoginThunk } from "../../services/actions/user_actions";
import eye from '../../images/eye.svg';
import {
  checkInput, getDataFromRoutes, setMetaTags, setPrimaryKeyInProductsList
} from "../../utils/util_functions";
import {
  EDIT_EMAIL_LOGIN, EDIT_PASSWORD, LOGIN_BUTTON_SWITCH
} from "../../services/actions/login_form_actions";
import { getLoginForm, getLoading, getCart } from "../../services/selectors";
import Loader from "../../components/loader/loader";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { ROUTES_CONST } from "../../utils/constants";


function Login() {

  const [statusEmail, setStatusEmail] = useState({});
  const [statusPassword, setStatusPassword] = useState({});

  const refToFPInput = useRef(null);

  const {
    email, password, button_disabled
  } = useSelector(getLoginForm);
  const isLoading = useSelector(getLoading);

  const cart = setPrimaryKeyInProductsList(useSelector(getCart).productsInCart);

  useEffect(() => {
    const validEmail = checkInput(email, 8, 64, 'email').valid;
    const validPassword = checkInput(password, 8, 64, 'password').valid;
    dispatch({
      type: LOGIN_BUTTON_SWITCH,
      button_disabled: !(validEmail && validPassword)
    });

    // eslint-disable-next-line
  }, [password, email]);



  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postLoginThunk(navigate, location.state?.from, password, email.toLowerCase(), cart));
  }


  const changeEmail = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'email');
    setStatusEmail({ ...statusEmail, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_EMAIL_LOGIN, email: e.target.value });
  }
  const changePassword = (e) => {
    if (e.target.value.length > 64) {
      e.target.value = e.target.value.slice(0, 64);
    }
    const currStatus = checkInput(e.target.value, 8, 64, 'password');
    setStatusPassword({ ...statusPassword, valid: currStatus.valid, text: currStatus.text });
    dispatch({ type: EDIT_PASSWORD, password: e.target.value });
  }

  const changeVisibilityFP = () => {
    refToFPInput.current.type === 'password' ?
      refToFPInput.current.type = 'string' :
      refToFPInput.current.type = 'password';
  }


  return (
    <main className='main'>
      {isLoading ? <Loader /> : null}
      <h1 className="title  title__left">{title}</h1>
      <div className={styles.box}>
        <form onSubmit={handleSubmit} className="form" noValidate >
          <h2 className="subtitle subtitle__left">
            У меня уже есть учётная запись
          </h2>
          <label htmlFor="email" className="label_text">
            Email <span style={{ color: 'red' }}>*</span>
            <input
              type="email"
              id="email" name="email"
              required={true}
              value={email}
              onChange={changeEmail}
              className="input"
            />
            <p className="error">{statusEmail?.text}</p>
          </label>
          <label htmlFor="first_password" className="label_text">
            Пароль <span style={{ color: 'red' }}>*</span>
            <input
              type="password"
              id="first_password" name="first_password"
              required={true}
              value={password}
              onChange={changePassword}
              className="input input__password"
              ref={refToFPInput}
              autoComplete="on"
            />
            <img src={eye} className="eye"
              alt='visibility first password' onClick={changeVisibilityFP}
            />
            <p className="error">{statusPassword?.text}</p>
          </label>
          <div className={styles.button_container}>
            <button type="submit"
              className={`button ${button_disabled ? 'button_disabled' : ''}`}
              disabled={button_disabled}
            >
              Войти
            </button>
            <div className={styles.links_container}>
              <Link to='/forgot-password' className={styles.link}>
                Сброс пароля
              </Link>
              <Link to='/resend-activation' className={styles.link}>
                Активация аккаунта
              </Link>
            </div>
          </div>
        </form>

        <div className={styles.aside_block}>
          <h2 className="subtitle subtitle__left">
            Я - новый покупатель
          </h2>
          <p className="text__gray">
            Регистрация на сайте позволит быстро оформлять заказы,
            управлять заказами через личный кабинет, в полном объеме
            использовать возможности нашего интернет магазина.
          </p>
          <Link to='/register' className='button'>
            Регистрация
          </Link>
        </div>
      </div>
    </main>
  );
}

export default Login;
